const shouldConvertFromCentimetersToMeters = (key: string) =>
    key === "height" ||
    key === "length" ||
    key === "offset" ||
    key === "width" ||
    key === "thickness" ||
    key === "graphic_thickness" ||
    key === "diameter";

export default shouldConvertFromCentimetersToMeters;
